export function showSideMenu() {
  const sideMenu = document.getElementById('sidr')
  const sideMenuButton = document.getElementById('side-menu')

  $(sideMenuButton).sidr()
  sideMenu.classList.remove('container-hidden')

  document.getElementById('infografias-menu').onclick = () =>
    document.getElementById('infografias-submenu').classList.toggle('submenu-open')
}